import { createSelector } from '@reduxjs/toolkit';
import { ALL_SUB_APPLICATION } from '@/constant/global/global.constant';
import { RootState } from '../types';

const getsubapplication = function (state: RootState) {
  return state.subapplication;
};

export const geSubApplications = createSelector(
  getsubapplication,
  (subApplication) => subApplication,
);

export const subApplicationList = createSelector(
  geSubApplications,
  (subApplication) => {
    return [ALL_SUB_APPLICATION].concat(
      (subApplication as any)?.subApplications?.data?.map((application: any) => ({
        id: application?.id,
        name: application?.name,
      })),
    );
  },
);
